import useSWR from 'swr';
import { customSWRConfig, customSWRResponse } from '../../model/types';
// import { fetcherWithToken } from '../../utils/fetchers';
import useSWRCacheKeys from '../useSWRCacheKeys';

interface ChartData {
    /**
     * @description array of colors in CSS format
     * @example ['#d62728', '#2ca02c', '#000000']
     */
    c?: string[];
    d: ReportData[];
}
interface ReportData {
    k: string;
    v: number | string;
    /**
     * @i 'integer'
     * @p 'percentage'
     */
    t: 'n' | 'p' | 's';
}

interface TableData {
    columns: string[];
    data: string[][];
}
type ReportType = 'box' | 'chart' | 'table';

export default function useReports<T extends ReportType>(
    reportUrl: string,
    refreshInterval = 0,
    config: customSWRConfig = {}
): customSWRResponse<
    T extends 'table' ? TableData : T extends 'chart' ? ChartData : T extends 'box' ? ChartData : never
> {
    const keys = useSWRCacheKeys(reportUrl);

    return useSWR(keys, { ...config, refreshInterval: refreshInterval * 1000 }) as customSWRResponse<
        T extends 'table' ? TableData : T extends 'chart' ? ChartData : T extends 'box' ? ChartData : never
    >;
}

export { type ChartData, type ReportData, type TableData };
